// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateDocumentDownloadTokenMutationVariables = Types.Exact<{
  documentID: Types.Scalars['ID']['input'];
}>;


export type GenerateDocumentDownloadTokenMutation = { __typename?: 'Mutation', requestDocumentDownload: { __typename?: 'DocumentDownloadToken', expiresInSeconds: number, token: string } };

export type GenerateFileDownloadTokenMutationVariables = Types.Exact<{
  fileID: Types.Scalars['ID']['input'];
}>;


export type GenerateFileDownloadTokenMutation = { __typename?: 'Mutation', requestFileDownload: { __typename?: 'FileDownloadToken', expiresInSeconds: number, token: string } };

export const Operations = {
  Mutation: {
    GenerateDocumentDownloadToken: 'GenerateDocumentDownloadToken' as const,
    GenerateFileDownloadToken: 'GenerateFileDownloadToken' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateDocumentDownloadTokenDocument = gql`
    mutation GenerateDocumentDownloadToken($documentID: ID!) {
  requestDocumentDownload(documentID: $documentID) {
    expiresInSeconds
    token
  }
}
    `;
export type GenerateDocumentDownloadTokenMutationFn = Apollo.MutationFunction<GenerateDocumentDownloadTokenMutation, GenerateDocumentDownloadTokenMutationVariables>;

/**
 * __useGenerateDocumentDownloadTokenMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentDownloadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentDownloadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDocumentDownloadTokenMutation, { data, loading, error }] = useGenerateDocumentDownloadTokenMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useGenerateDocumentDownloadTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDocumentDownloadTokenMutation, GenerateDocumentDownloadTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDocumentDownloadTokenMutation, GenerateDocumentDownloadTokenMutationVariables>(GenerateDocumentDownloadTokenDocument, options);
      }
export type GenerateDocumentDownloadTokenMutationHookResult = ReturnType<typeof useGenerateDocumentDownloadTokenMutation>;
export type GenerateDocumentDownloadTokenMutationResult = Apollo.MutationResult<GenerateDocumentDownloadTokenMutation>;
export type GenerateDocumentDownloadTokenMutationOptions = Apollo.BaseMutationOptions<GenerateDocumentDownloadTokenMutation, GenerateDocumentDownloadTokenMutationVariables>;
export const GenerateFileDownloadTokenDocument = gql`
    mutation GenerateFileDownloadToken($fileID: ID!) {
  requestFileDownload(fileID: $fileID) {
    expiresInSeconds
    token
  }
}
    `;
export type GenerateFileDownloadTokenMutationFn = Apollo.MutationFunction<GenerateFileDownloadTokenMutation, GenerateFileDownloadTokenMutationVariables>;

/**
 * __useGenerateFileDownloadTokenMutation__
 *
 * To run a mutation, you first call `useGenerateFileDownloadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFileDownloadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFileDownloadTokenMutation, { data, loading, error }] = useGenerateFileDownloadTokenMutation({
 *   variables: {
 *      fileID: // value for 'fileID'
 *   },
 * });
 */
export function useGenerateFileDownloadTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFileDownloadTokenMutation, GenerateFileDownloadTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFileDownloadTokenMutation, GenerateFileDownloadTokenMutationVariables>(GenerateFileDownloadTokenDocument, options);
      }
export type GenerateFileDownloadTokenMutationHookResult = ReturnType<typeof useGenerateFileDownloadTokenMutation>;
export type GenerateFileDownloadTokenMutationResult = Apollo.MutationResult<GenerateFileDownloadTokenMutation>;
export type GenerateFileDownloadTokenMutationOptions = Apollo.BaseMutationOptions<GenerateFileDownloadTokenMutation, GenerateFileDownloadTokenMutationVariables>;